<nb-card>
  <nb-card-header>
    <div class="text-heading">Bình luận mới</div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <div class="row">
      <div *ngFor="let item of comments; let i = index" class="col-md-12">
        <ngx-view-comment
          [comment]="item"
          (onDelete)="onDelete($event)"
        ></ngx-view-comment>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <!-- <nb-card-footer *ngIf="!done">
    <nb-actions size="small" class="see-more-button">
      <nb-action (click)="loadMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer> -->
</nb-card>
